import { useState } from "react"
import { Flex, Input, Modal, Form, DatePicker } from "antd"
import ProgramStepper from "../ProgramStepper"
import { useUser } from "../../../contexts/UserContext"


export const ValveControlModal = ({ onClose, metaData, programState }) => {

    const handleClose = () => onClose()
    const { remoteProps } = useUser()
    const handleCancelSchedule = () => handleClose()
    const allSteps = [{ positionID: 0, timespan: 0 }, { positionID: 2, timespan: 0 }, { positionID: 3, timespan: 0 }, { positionID: 5, timespan: 0 }, { positionID: 6, timespan: 0 }, ...(remoteProps.ValveSize == 1 ? [{ positionID: 7, timespan: 0 }] : [])]

    function mapValveIndex(index){
        switch (index) {
            case 0:
                return 0
            case 1:
                return 0 //Invalid!
            case 2:
                return 1
            case 3:
                return 2
            case 4:
                return 0 //Invalid!
            case 5:
                return 3
            case 6:
                return 4
        }
    }

    return (
        <Modal footer={null} width={remoteProps.ValveSize == 2 ? '800px' : '635px'} height={'300px'} onCancel={handleCancelSchedule} cancelText="Stäng" open>
            <ProgramStepper metaData={metaData} style={{ marginTop: '80px' }} steps={allSteps} currentStep={mapValveIndex(programState.currentPosition)} progressStep={undefined} />
        </Modal>
    )
}
export default ValveControlModal